import "./endorsements-affiliations.css";
import ajax from "@/scripts/common/ajax";

document.addEventListener("filter-change", async (e) => {
  const { href } = e.detail;
  const pageContent = document.querySelector("[data-page-content]");

  const loadingTimeout = setTimeout(() => {
    pageContent.classList.add("is-loading");
  }, 300);

  const res = await ajax.get(href).json();

  clearTimeout(loadingTimeout);

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");
});
